import React, { Component } from "react";
import { Card } from "react-bootstrap";
import {
  Container,
  Typography,
  Grid,
  CardContent,
  CardActions,
  Button,
} from "@material-ui/core";
import { PostData } from "../../api/service";
import BreadCrumbOwn from "../Essentials/BreadCrumbOwn";
import { resolveReport } from "./reportsConfig";

export default class ReportsComponent extends Component {
  state = {
    data: [],
    isLoaded: false,
    config: null,
  };

  componentDidMount() {
    this.__load();
  }

  componentDidUpdate(prevProps) {
    // Same component instance is reused across the different report
    // sub-routes, so re-fetch whenever the pathname changes.
    if (prevProps.location.pathname !== this.props.location.pathname) {
      this.__load();
    }
  }

  __load = () => {
    const config = resolveReport(this.props.location.pathname);

    if (!config) {
      this.setState({ config: null, data: [], isLoaded: true });
      return;
    }

    this.setState({ isLoaded: false, config });

    PostData(`/getreportsbysubcategory`, {
      category: config.category,
      sub_category: config.sub_category,
    })
      .then((resp) => {
        this.setState({
          data: Array.isArray(resp) ? resp : [],
          isLoaded: true,
        });
      })
      .catch(() => {
        this.setState({ data: [], isLoaded: true });
      });
  };

  render() {
    const { config, data, isLoaded } = this.state;
    const title = config ? config.label : "Reports";

    return (
      <div>
        <BreadCrumbOwn title={title} />

        <div style={{ minHeight: "100vh" }}>
          <Container className="mb-5">
            <Typography
              variant="h5"
              style={{ marginTop: "1em", marginBottom: "1em", fontWeight: 700 }}
            >
              {title}
            </Typography>

            {isLoaded ? (
              <Grid container spacing={2}>
                {data.map((el, index) => (
                  <Grid item key={index} xs={12} sm={12} lg={12} md={12}>
                    <Card
                      style={{
                        boxShadow: "none",
                        backgroundColor: "#F3F3F3",
                        border: "solid 1px #B9B9B9",
                      }}
                    >
                      <CardContent>
                        <Typography variant="caption">
                          Posted on <strong>{el.date}</strong> by{" "}
                          <span style={{ fontWeight: 700, color: "#2054CD" }}>
                            {el.posted_as}
                          </span>
                        </Typography>
                        <Typography variant="h6" gutterBottom>
                          {el.title}
                        </Typography>
                        <Typography
                          variant="body2"
                          dangerouslySetInnerHTML={{ __html: el.description }}
                        ></Typography>
                      </CardContent>

                      {Array.isArray(el.upload_info) &&
                      el.upload_info.length > 0 ? (
                        <CardActions>
                          {el.upload_info.map((el1, index1) => (
                            <Button
                              size="small"
                              key={index1}
                              color="primary"
                              style={{ border: "solid 1px #B9B9B9" }}
                              target="_blank"
                              href={el1.url}
                            >
                              Attachment {index1 + 1}
                            </Button>
                          ))}
                        </CardActions>
                      ) : null}
                    </Card>
                  </Grid>
                ))}

                {data.length === 0 ? (
                  <Grid item xs={12}>
                    <Typography>No {title} available.</Typography>
                  </Grid>
                ) : null}
              </Grid>
            ) : (
              <Typography>Loading . . . </Typography>
            )}

            <br />
            <br />
          </Container>
        </div>
      </div>
    );
  }
}
